import { Component } from '@angular/core';
import { Dotcom2024Service } from '../dotcom2024.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-bill-and-hold-agreement',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './bill-and-hold-agreement.component.html',
  styleUrl: './bill-and-hold-agreement.component.css'
})
export class BillAndHoldAgreementComponent {

  bhAgreement: any = {};
  bhAgreementData: any[] = [];
  validSignature: boolean = false;
  dateSigned: Date;
  printedName: string;
  signedName: string;
  title: string;
  repName: string;
  repID: string;
  bhId: string
  x: any;
  submitSuccessful: boolean = false;

  imagefilePath = environment.azureBlobStorageURL + environment.baseImagesFilePathBlobStorage;

  constructor(public dotComService: Dotcom2024Service) { }

  ngOnInit() {
    //get the query string parameters
    if (typeof document !== 'undefined') {
      // let queryString = document.location.search;
      // let urlParams = new URLSearchParams(queryString);
      // this.dotComService.bhGUID = urlParams.get('id');

      //using the / syntax before the parameter in the email that goes to the user
      this.dotComService.bhGUID = document.location.pathname.toLowerCase().substring(document.location.pathname.toLowerCase().indexOf('agreement/')+10);

      this.GetBHAgreement();
    }
  }

  GetBHAgreement() {
    this.dotComService.GetBillandHoldDetail().subscribe((data: any) => {
      //most stuff in the array elements are the same so just grab the first one 
      //for some content 
      this.bhAgreement = data[0];
      this.repName = data[0].RepName;
      this.repID = data[0].RepID;
      this.bhId = data[0].BHAgreementID

      this.bhAgreementData = [];
      for (let index = 0; index < data.length; index++) {
        const element = data[index];
        //format the date mo fos
        let z = new Date(element.DOCDATE);
        element.DOCDATE = z.toLocaleDateString("en-US");
        this.bhAgreementData.push(element);
      }
    })
  }

  CheckValid() {
     let x = (document.getElementById("dateSignedId") as HTMLInputElement).value
     this.dateSigned = new Date(new Date(x).toUTCString());
    if (this.printedName != "" && this.printedName != undefined && this.signedName != "" && this.signedName != undefined && this.title != "" && this.title != undefined && x.toString() != 'Invalid Date' && x.toString() != '') {
      this.validSignature = true;
    }
    else {
      this.validSignature = false
    }

  }

  DefaultDate() {
    //default to todays date but allow them to change it if they want
    let z = new Date();
    (document.getElementById("dateSignedId") as HTMLInputElement).value = z.getFullYear() + "-" + (z.getMonth() + 1) + "-" + z.getDate();
    this.dateSigned = new Date(new Date().toLocaleDateString("en-US"));


    if (this.printedName != "" && this.printedName != undefined && this.signedName != "" && this.signedName != undefined && this.title != "" && this.title != undefined) {
      this.validSignature = true;
    }
    else {
      this.validSignature = false
    }
  }

  SubmitBHAgreement() {
    this.dotComService.GetClientIP().subscribe((ip: any) => {
      this.dotComService.SubmitBillAndHold(ip.ip, this.title, this.dotComService.bhGUID, this.signedName, this.printedName, this.dateSigned).subscribe((result: any) => {
        if (result == true) {
          this.submitSuccessful = true;
        }
      })
    })
  }


}
